<template>
   <div class="coverinfodetails">
        <v-layout row>
            <v-flex xs11 offset-xs1>
                <span class="header-title-details">{{$t('Cover.ShowCover.COVER_DETAILS_SUB_TITLE')}}</span>
                <a v-on:click='closeExtendedMode' class="right">  <span class="icon-close"></span></a>
            </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs11 offset-xs1>
                  <InvoiceInfo/>
                </v-flex>
            </v-layout>
            <v-layout row v-if="cover.details.originTab === 'Quoted'">
                <v-flex xs12>
                  <QuotedPriceDetails/>
                </v-flex>
            </v-layout>
            <v-layout row v-if="cover.details.originTab === 'Claimed'">
                <v-flex xs11 offset-xs1>
                  <ClaimInfo/>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs11 offset-xs1>
                  <InvoiceMoreDetails/>
                </v-flex>
            </v-layout>
            <v-layout row v-if="cover.details.originTab !== 'Quoted'">
                <v-flex xs11 offset-xs1>
                  <CoverDetailsInfo/>
                </v-flex>
            </v-layout>
    </div>
</template>
<script>
import InvoiceInfo from '@/components/cover/details/InvoiceInfo'
import InvoiceMoreDetails from '@/components/cover/details/InvoiceMoreDetails'
import CoverDetailsInfo from '@/components/cover/details/CoverDetailsInfo'
import QuotedPriceDetails from '@/components/cover/details/QuotedPriceDetails'
import ClaimInfo from '@/components/cover/claim/ClaimInfo'
import { mapState } from 'vuex'

export default {
  data () {
    return {
    }
  },
  methods: {
    closeExtendedMode () {
      this.$parent.initializeAndCloseExtendedMode()
    }
  },
  components: {
    InvoiceInfo,
    InvoiceMoreDetails,
    CoverDetailsInfo,
    ClaimInfo,
    QuotedPriceDetails
  },
  computed: {
    ...mapState('cover', ['cover'])
  }

}
</script>
